<template>
  <slideout-panel v-on:slideout:close="closePanel" :open="createProductPanelIsOpen" title="Create Product" >
    <div>
      <products-form />
    </div>
  </slideout-panel>
</template>

<script>
import SlideoutPanel from "@/components/Functional/SlideoutPanel";
import ProductsForm from "@/components/Products/ProductsForm";
export default {
  name: "CreateProductPanel",
  components: {ProductsForm, SlideoutPanel},
  props: ['open'],
  methods: {
    closePanel() {
      this.$store.dispatch('closeCreateProductPanel')
    }
  },
  computed: {
    createProductPanelIsOpen() {
      return this.$store.getters.getCreateProductPanelIsOpen
    },
  },
}
</script>

<style scoped>

</style>